import React, { Component } from 'react';
import GovernmentTableBase from './GovernmentTableBase';

const tableHeaders = ['Range', 'EE', 'ER','MaxLimit'];
const loadTableUrl = 'api/PagibigTable/load'
const saveTableUrl = 'api/PagibigTable/save'
const resetTableUrl = 'api/PagibigTable/reset'

export default class PagibigTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ minWidth: '500px', width: '100%' }}>
                <div style={{ color: "#606060", marginTop: '1%' }}>
                    <h2>Pagibig Table</h2>
                </div>

                <GovernmentTableBase
                    ref={(x) => this.baseTable = x}
                    headers={tableHeaders}
                    loadTableUrl={loadTableUrl}
                    saveTableUrl={saveTableUrl}
                    resetTableUrl={resetTableUrl}
                    eeSuffix='%'
                    erSuffix='%'
                    year={this.props.year}
                    resetButtonEnable={this.props.resetButtonEnable}
                />
            </div>
        )
    }
}